module.exports = __webpack_public_path__ + "img/b-time.f44dfb20.svg";